var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip.right",
          value: _vm.tooltipOptions,
          expression: "tooltipOptions",
          modifiers: { right: true }
        }
      ],
      staticClass: "likers-count-component post-likers",
      on: {
        click: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.openLikersModal($event)
        }
      }
    },
    [_vm._v("\n    " + _vm._s(_vm.likesCount) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }